// const logToLogEntries = (message: string) => {
//   if (typeof fetch !== 'undefined') {
//     fetch(
//       `${'https://events.wix.com/_api/wix-one-events-server'}/log`,
//       {
//         method: 'PUT',
//         headers: [['Content-Type', 'application/json']],
//         body: JSON.stringify({
//           message
//         })
//       }
//     )
//   }
// }

export const logDuration = (type: string) => {
  if (actionsMap[type]) {
    const duration = new Date().valueOf() - actionsMap[type]
    actionsMap[type] = undefined
    console.log(`SSR: ${duration} : ${type}`)
  } else {
    actionsMap[type] = new Date().valueOf()
  }
}

export const logTime = (type: string) => {
  console.log(`SSR: ${new Date().valueOf()} : ${type}`)
}

const actionsMap = {}

export const FETCH_DATA = 'FETCH_DATA'
export const CREATE_CONTROLLER = 'CREATE_CONTROLLER'
